import React, { useEffect, useState } from 'react';
import './create-eval.styles.scss'

import CreateEvalForm from './create-eval-form.component'
import CreateEvalFormV2 from './create-eval-form-v2.component';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../SHARED/back-button/back-button.component';

const NewEval = () => {

  const { evalPath } = useParams();
  const navigate = useNavigate();

  return (
    <div className='create-eval'>
      <div className='g-card create-eval-card'>
        {
          evalPath &&
          <div >
            <BackButton cancel={() => navigate(-1)} />
          </div>

        }
        <h3>Create a New Evaluation</h3><hr />
        <CreateEvalFormV2 />
      </div>
    </div>
  )
}

export default NewEval;